export default function showNotification(
  message,
  type = "success",
  duration = 3000
) {
  const notification = document.createElement("div");
  notification.className = `custom-notification ${type}`;
  notification.innerText = message;

  // Append to body
  document.body.appendChild(notification);

  // Remove after duration
  setTimeout(() => {
    notification.classList.add("hide");
    setTimeout(() => {
      notification.remove();
    }, 300);
  }, duration);
}
